<iframe
  src="https://client-hub.helpscoutdocs.com/article/83-client-hub-referral-partner-program"
  frameborder="0"
  class="referral-program-iframe"
></iframe> 